import './vendor/jquery.min.js'
import './vendor/jquery.easing.min.js'
import './vendor/micromodal.min.js'

import contentLoaded from './vendor/contentloaded.min.js'
import './vendor/jquery.viewportchecker.min.js'
import images from './images.js'
import multistep from './multi-step-form.js'
import phoneConcat from './phone-concatination.js'
import polyfill from './polyfills.js'
import sliders from './sliders.js'
import smoothScroll from './smooth-scroll.js'
import stickyHeader from './sticky-header.js'
import viewAnimation from './view-animation.js'
import getCurrentMonth from './month.js'
import kkThankYou from './thank-you.js';
import popups from './popup.js';

contentLoaded()


window.contentLoaded(window, function (e) {
	polyfill()
	kkThankYou();
	phoneConcat()
	images()
	getCurrentMonth()
	popups();
	sliders();

	smoothScroll()
	stickyHeader()
	viewAnimation()
	getCurrentMonth()
	multistep();
})
